import {
  base_contentActive,
  base_contentHover,
  table_tableRowSelectedHover,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_regular,
  font_md,
  font_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  &.VendorSelectOption {
    min-height: ${spacing(11)};
    display: flex;
    align-items: center;
    gap: ${spacing(3)};
    padding: ${spacing(2)} ${spacing(4)};
    cursor: pointer;
    ${font_md};
    font-family: ${font_family_weight_regular};
    color: ${text_colorTextPrimary};

    .avatar {
      flex-shrink: 0;
    }

    .option-label-wrapper {
      display: flex;
      flex-direction: column;
      gap: ${spacing(1)};
      overflow: hidden;
      flex: 1;
      min-width: 0;
    }

    .option-email {
      ${font_sm};
      color: ${text_colorTextSecondary};
    }

    .ellipsis {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .selected-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      margin-left: ${spacing(2)};
    }

    &:hover,
    &:focus,
    &[aria-selected='true'] {
      background-color: ${base_contentHover};
      outline: none;
    }

    &.selected {
      background-color: ${base_contentActive};
      &:hover,
      &:focus,
      &[aria-selected='true'] {
        background-color: ${table_tableRowSelectedHover};
      }
    }
  }
`
